export default "__VITE_ASSET__746d011d__"